<template>
  <card-seplag :titulo="'Capacitação'" cor="#00acc1">
    <div class="p-col-12 avisos">
      <b>Cursos de capacitação se referem a participação em Congresso, curso, estágio profissional, eventos artísticos, eventos científicos, eventos culturais, eventos educacionais, Fórum, Intercâmbio, Palestra, Seminário, Simpósio, Treinamento em serviço, Oficina/Workshop.</b>
    </div>
    <card-seplag :titulo="'Dados da capacitação'" class="" cor="#00acc1" v-if="exibirNovaCapacitacao"
      :legendaObrigatorio="true">
      <Rotulo nome="Curso" cols="12 6">
        <InputText ref="descCurso" type="text" v-model="dadosCapacitacao.descCurso"
          @input="converteMaiuscula('dadosCapacitacao.descCurso')" @change="verificaAlteracaoDeCampo()" v-required
          autofocus />
        <!-- <Dropdown v-model="dadosCapacitacao.descCurso" :options="cursos" optionLabel="descAreaFormacao"
          optionValue="descAreaFormacao" @change="verificaAlteracaoDeCampo()" placeholder="Selecione..." :filter="true"
          v-required /> -->
        <!--<AutoComplete v-model="dadosCapacitacao.descCurso" @input="converteMaiuscula('dadosCapacitacao.descCurso')"  :suggestions="teste" @complete="searchFormacao($event)" v-required />-->
        <!-- <AutoComplete
          v-model="dadosCapacitacao.descCurso"
          :suggestions="resultadoBusca"
          @complete="searchDescCurso($event)"
          @input="converteMaiuscula('dadosCapacitacao.descCurso')"
          v-required
        /> -->
      </Rotulo>
      <!-- <Rotulo nome="Área da formação" cols='12 6'>
                <Dropdown v-model="dadosCapacitacao.areaFormacao" :filter="true" :options="areaformacoes" optionLabel="descAreaFormacao" placeholder="Selecione..." v-required  />
            </Rotulo> -->
      <!-- <Rotulo nome="Área do conhecimento" cols='12 6'>
                <Dropdown v-model="dadosCapacitacao.areaConhecimento" :filter="true" :options="areasConhecimento" optionLabel="descAreaConhecimento" placeholder="Selecione..." v-required  />
            </Rotulo> -->

      <Rotulo nome="Modalidade" cols="12 6">
        <Dropdown v-model="selectedModalidade" :options="modalidades" optionLabel="name"
          @change="verificaAlteracaoDeCampo()" placeholder="Selecione..." :filter="true" v-required />
      </Rotulo>

      <Rotulo nome="Eventos" cols="12 6">
        <Dropdown v-model="dadosCapacitacao.formacaoContinuada" :options="formacaoContinuada"
          optionLabel="nomeFormacaoContinuada" @change="verificaAlteracaoDeCampo()" placeholder="Selecione..."
          :filter="true" v-required />
      </Rotulo>
      <Rotulo nome="Carga horária" cols="12 3">
        <InputNumber v-model="dadosCapacitacao.qtdeCargaHoraria" :useGrouping="false" mode="decimal" :min="0" />
      </Rotulo>
      <Rotulo nome="Data da conclusão" cols="12 3">
        <InputMask v-model="dadosCapacitacao.dataAnoConclusao" mask="99/99/9999" placeholder="99/99/9999" v-required
          @change="verificaAlteracaoDeCampo()" />
      </Rotulo>
      <Rotulo nome="Instituição" cols="12 6">
        <AutoComplete v-model="dadosCapacitacao.descInstituicao" :suggestions="resultadoBusca"
          @complete="searchDescInstituicao($event)" @input="converteMaiuscula('dadosCapacitacao.descInstituicao')"
          v-required />
      </Rotulo>
      <div class="p-col-12">
        <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-2 p-md-offset-8" v-if="flagEdicao">
            <Button class="p-button-danger" label="Cancelar Edição" @click="fecharNovaCapacitacao()" icon="pi pi-times"
              iconPos="left" style="margim-right: 0" />
          </div>
          <div class="p-col-12 p-md-2" v-if="flagEdicao">
            <Button label="Salvar Edição" @click="finalizarEdicaoCapacitacao()" icon="pi pi-pencil" iconPos="left"
              style="margim-right: 0" />
          </div>
          <div class="p-col-12 p-md-2 p-md-offset-6" v-if="!flagEdicao && camposPreenchidos">
            <Button class="p-button-info" label="Limpar Campos" @click="novaCapacitacao()" icon="pi pi-times"
              iconPos="left" style="margim-right: 0" />
          </div>
          <div class="p-col-12 p-md-2" v-if="!flagEdicao && camposPreenchidos">
            <Button class="p-button-success" label="Incluir" @click="adicionarCapacitacao()" icon="pi pi-check"
              iconPos="left" />
          </div>
          <div class="p-col-12 p-md-2 p-md-offset-8" v-if="!flagEdicao && !camposPreenchidos">
            <Button class="p-button-success" label="Incluir" @click="adicionarCapacitacao()" icon="pi pi-check"
              iconPos="left" />
          </div>
          <div class="p-col-12 p-md-2" v-if="!flagEdicao">
            <Button class="p-button-danger" label="Cancelar" @click="fecharNovaCapacitacao()" icon="pi pi-times"
              iconPos="left" />
          </div>
        </div>
      </div>
    </card-seplag>
    <card-seplag :titulo="'Capacitações cadastradas'" class="ajusteSecao" cor="#00acc1">
      <div class="p-col-12 ajusteSecao">
        <div v-if="capacitacoes && capacitacoes.length > 0" class="p-col-12 ajustePanel">
          <button v-for="(capacitacao, index) in capacitacoes" :key="capacitacao.idenCapacitacao" type="button"
            @click="funcaoAccord(index)" class="p-col-12 ajustePanel">
            <Panel :toggleable="true" :collapsed="controlePanel[index]" class="p-col-12 ajustePanel">
              <template slot="header">
                <span class="acordion">{{ colapseTeste }}</span>
                <span>
                  {{ index + 1 + " - " + capacitacao.descCurso }}
                  <span v-if="capacitacao.statCapacitacao == 'REJEITADO'"
                    class="statusVinculoIrregular alinhamentoNome">Rejeitado</span>
                  <span v-if="capacitacao.statCapacitacao == 'PENDENTE'"
                    class="statusVinculoPendente alinhamentoNome">Pendente</span>
                  <span v-if="capacitacao.statCapacitacao == 'PENDENTE_VALIDACAO'"
                    class="statusVinculoPendente alinhamentoNome">AGUARDANDO VALIDAÇÃO</span>
                  <span v-if="capacitacao.statCapacitacao == 'CONCLUIDO'"
                    class="statusVinculoConcluido alinhamentoNome">Concluído</span>
                  <span v-if="capacitacao.statCapacitacao == 'VALIDADO'"
                    class="statusVinculoConcluido alinhamentoNome">Validado</span>
                </span>
                <span class="acordion">{{ isCollapsed }}</span>
              </template>
              <div class="p-grid p-fluid">
                <div class="p-col-12 ajusteContent" v-if="capacitacao.codgModalidadeEnsinoSeap">
                  <label><strong>Modalidade: </strong>{{
                    verifcarModalidade(capacitacao.codgModalidadeEnsinoSeap)
                  }}</label>
                </div>
                <div class="p-col-12 ajusteContent" v-if="capacitacao.formacaoContinuada">
                  <label><strong>Eventos: </strong>{{
                    capacitacao.formacaoContinuada.nomeFormacaoContinuada
                  }}</label>
                </div>
                <div class="p-col-12 ajusteContent" v-if="capacitacao.descInstituicao">
                  <label><strong>Instituição: </strong>{{ capacitacao.descInstituicao }}</label>
                </div>
                <div class="p-col-12 ajusteContent" v-if="capacitacao.qtdeCargaHoraria">
                  <label><strong>Carga horária: </strong>{{ capacitacao.qtdeCargaHoraria }}</label>
                </div>
                <div class="p-col-12 p-md-12 ajusteContent" v-if="capacitacao.dataAnoConclusao">
                  <label><strong>Data da conclusão: </strong>{{ capacitacao.dataAnoConclusao }}</label>
                </div>
                <div class="p-col-12 p-md-4">
                  <Button label="Editar" icon="pi pi-pencil" @click="editarCapacitacao(capacitacao, index)"
                    class="p-button-success" />
                </div>
                <div class="p-col-12 p-md-4">
                  <Button label="Excluir" icon="pi pi-trash" @click="abrirDialogoDeletar(capacitacao)"
                    class="p-button-danger" />
                </div>
              </div>
            </Panel>
          </button>
        </div>

        <span v-else><i>Nenhum registro encontrado</i></span>
        <div class="p-col-12 p-md-3 p-md-offset-9" v-if="!exibirNovaCapacitacao">
          <Button class="p-button-info" label="Cadastrar nova capacitação" @click="exibeNovaCapacitacaoEScroolaParaOInicio()"
            icon="pi pi-save" iconPos="left" style="margim-right: 0" />
        </div>
      </div>
    </card-seplag>

    <div class="p-col-12">
      <div class="p-grid">
        <div class="p-col-12 p-md-2 p-md-offset-3">
          <Button label="Voltar" @click="prevPage()" icon="pi pi-angle-left" />
        </div>
        <div class="p-col-12 p-md-2">
          <Button label="Finalizar Etapa" @click="concluirEtapa()" icon="pi pi-check" class="p-button-success" />
        </div>
        <div class="p-col-12 p-md-2">
          <Button label="Próximo" @click="nextPage()" icon="pi pi-angle-right" iconPos="right" />
        </div>
      </div>
    </div>

    <Dialog header="Confirmação!!" :visible.sync="exibirDialogoDeletar" :style="{ width: '33vw' }" :modal="true"
      v-if="exibirDialogoDeletar">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color: red" />
        <span>Você tem certeza que deseja <strong>EXCLUIR</strong> a Formação
          Acadêmica <strong>{{ dadosCapacitacao.descCurso }}</strong>?</span>
      </div>
      <template #footer>
        <Button label="Fechar" icon="pi pi-times" @click="fecharDialogoDeletar" class="p-button-text" />
        <Button label="Sim" icon="pi pi-trash" @click="removerCapacitacao()" class="p-button-text p-button-danger"
          autofocus />
      </template>
    </Dialog>
  </card-seplag>
</template>
<script>
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import { baseApiUrl } from "@/config/global";
import InputNumber from "primevue/inputnumber";

const getDadosCapacitacao = () => {
  return {
    descCurso: null,
    areaFormacao: null,
    areaConhecimento: null,
    formacaoContinuada: null,
    qtdeCargaHoraria: null,
    dataAnoConclusao: "",
    descInstituicao: null,
    codgModalidadeEnsinoSeap: null,
  };
};

export default {
  name: "capacitacao",
  components: { CardSeplag, Rotulo, InputNumber },
  data: function () {
    return {
      dadosCapacitacao: getDadosCapacitacao(),
      areasConhecimento: [],
      areaformacoes: [],
      formacaoContinuada: [],
      capacitacoes: [],
      flagEdicao: false,
      controleAccord: [],
      exibirDialogoDeletar: false,
      exibirNovaCapacitacao: false,
      camposPreenchidos: false,
      selectedModalidade: null,
      modalidades: [
        { name: "EaD", code: "EAD" },
        { name: "SemiPresencial", code: "SEMIPRESENCIAL" },
        { name: "Presencial", code: "PRESENCIAL" },
      ],
      cursos: [],
      resultadoBusca: null,
      teste: null,
      listaCursos: [],
      isCollapsed: false,
      controlePanel: [],
      colapseTeste: [],
    };
  },
  methods: {
    async carregarDados() {
      if (this.$store.getters.getDadosPessoa) {
        this.areasConhecimento = this.$store.getters.getAreasConhecimento;
        this.formacaoContinuada = this.$store.getters.getFormacaoContinuadas;
        // this.areaformacoes = this.$store.getters.getAreaFormacoes;
          this.$http.get(`${baseApiUrl}/formacaocontinuadas/ativos`).then(res =>{
           this.formacaoContinuada = res.data
          })
         this.$http
          .get(
            `${baseApiUrl}/capacitacoes/ciclopessoa/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
          )
          .then((res) => {
            this.capacitacoes = res.data;
            for (let i = 0; i < this.capacitacoes.length; i++) {
              this.controlePanel[i] = true;
              this.colapseTeste[i] = false;
            }
          });

        this.$http.get(`${baseApiUrl}/areaformacoes/ativos`).then((res) => {
          this.cursos = res.data;
          this.cursos.forEach((item) => {
            if (item) {
              this.listaCursos.push(
                this.especialCharMask(item.descAreaFormacao)
              );
            }
          });
          this.cursos = this.listaCursos;
        });
      } else {
        this.$router.push({ name: "recadastramento" });
      }
      
    },
    editarCapacitacao(dados, index) {
      window.scrollTo(0, 0);
      this.dadosCapacitacao = Object.assign({}, dados);
      this.selectedModalidade = this.modalidades.find(
        (item) => item.code == this.dadosCapacitacao.codgModalidadeEnsinoSeap
      );
      this.controleAccord[index] = false;
      this.flagEdicao = true;
      this.exibirNovaCapacitacao = true;
      setTimeout(() => {
        this.$refs.descCurso.$el.focus();
        var scrollToTop = window.setInterval(function () {
          var pos = window.pageYOffset;
          if (pos > 0) {
            window.scrollTo(0, pos - 20);
          } else {
            window.clearInterval(scrollToTop);
          }
        }, 16);
      }, 0);
    },
    removerCapacitacao() {
      if (this.dadosCapacitacao.idenCapacitacao) {
        this.$http
          .delete(
            `${baseApiUrl}/capacitacoes/${this.dadosCapacitacao.idenCapacitacao}`
          )
          .then(() => {
            this.dadosCapacitacao = getDadosCapacitacao();
            this.flagEdicao = false;
            this.exibirDialogoDeletar = false;
            this.$http
              .get(
                `${baseApiUrl}/capacitacoes/ciclopessoa/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
              )
              .then((res2) => {
                this.capacitacoes = res2.data;
                this.controleAccord = [];
                for (let i = 0; i < this.capacitacoes.length; i++) {
                  this.controleAccord[i] = false;
                }
                this.$toast.add({
                  severity: "success",
                  summary: "Capacitação excluída com sucesso!",
                  life: 10000,
                });
              });
          });
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Erro ao excluir",
          detail:
            "Ocorreu um erro ao carregar o item a ser excluido, por favor tente novamente!",
          life: 10000,
        });
        this.dadosCapacitacao = getDadosCapacitacao();
        this.flagEdicao = false;
        this.exibirDialogoDeletar = false;
      }
    },
    novaCapacitacao() {
      this.dadosCapacitacao = getDadosCapacitacao();
      this.camposPreenchidos = false;
      this.flagEdicao = false;
    },
    fecharDialogoDeletar() {
      this.novaCapacitacao();
      this.exibirDialogoDeletar = false;
    },
    abrirDialogoDeletar(capacitacao) {
      this.dadosCapacitacao = Object.assign({}, capacitacao);
      this.exibirDialogoDeletar = true;
    },
    adicionarCapacitacao() {
      this.dadosCapacitacao.codgModalidadeEnsinoSeap = this.selectedModalidade
        ? this.selectedModalidade.code
        : null;
      this.$http
        .post(
          `${baseApiUrl}/capacitacoes/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`,
          JSON.stringify(this.dadosCapacitacao)
        )
        .then(() => {
          this.dadosCapacitacao = getDadosCapacitacao();
          this.flagEdicao = false;
          this.$http
            .get(
              `${baseApiUrl}/capacitacoes/ciclopessoa/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
            )
            .then((res2) => {
              this.capacitacoes = res2.data;
              this.controleAccord = [];
              for (let i = 0; i < this.capacitacoes.length; i++) {
                this.controleAccord[i] = false;
              }
              this.exibirNovaCapacitacao = false;
              this.$toast.add({
                severity: "success",
                summary: "Capacitação salva com sucesso!",
                life: 6000,
              });
            });
        });
    },
    finalizarEdicaoCapacitacao() {
      this.dadosCapacitacao.codgModalidadeEnsinoSeap = this.selectedModalidade
        ? this.selectedModalidade.code
        : null;
      if (this.dadosCapacitacao.idenCapacitacao) {
        this.$http
          .put(
            `${baseApiUrl}/capacitacoes/${this.dadosCapacitacao.idenCapacitacao}`,
            JSON.stringify(this.dadosCapacitacao)
          )
          .then(() => {
            this.dadosCapacitacao = getDadosCapacitacao();
            this.flagEdicao = false;
            this.$http
              .get(
                `${baseApiUrl}/capacitacoes/ciclopessoa/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
              )
              .then((res2) => {
                this.capacitacoes = res2.data;
                this.controleAccord = [];
                for (let i = 0; i < this.capacitacoes.length; i++) {
                  this.controleAccord[i] = false;
                }
                this.fecharNovaCapacitacao();
                this.$toast.add({
                  severity: "success",
                  summary: "Capacitação atualizada com sucesso!",
                  life: 10000,
                });
              });
          });
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Erro ao salvar alteração",
          detail:
            "Ocorreu um erro ao enviar as alterações, porfavor tente novamente!",
          life: 10000,
        });
        this.dadosCapacitacao = getDadosCapacitacao();
        this.fecharNovaCapacitacao();
        this.flagEdicao = false;
      }
    },
    concluirEtapa() {
      if (this.$store.getters.getDadosPessoa) {
        this.$http
          .put(
            `${baseApiUrl}/capacitacoes/concluir/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`
          )
          .then((res) => {
            this.$http
              .get(
                `${baseApiUrl}/ciclopessoafases/ciclopessoa/${this.$store.getters.getCicloPessoa[0].idenCicloPessoa}`
              )
              .then((res2) => {
                let flag =
                  this.$store.getters.getDadosPessoa.pessoa.flagServidor != "S";
                let etapaCliclo = res2.data.filter(function (etapa) {
                  if (
                    etapa.fase.statFase != "INATIVO" &&
                    etapa.fase.descFase != "TERMO_ACEITE"
                  ) {
                    if (etapa.fase.descFase == "VINCULOS" && flag) {
                      return false;
                    } else {
                      return true;
                    }
                  } else {
                    return false;
                  }
                });
                this.$store.commit(
                  "setEtapasCiclo",
                  JSON.stringify(etapaCliclo)
                );
                this.$toast.add({
                  severity: "success",
                  summary: res.data,
                  life: 3000,
                });
                this.$http
                  .get(
                    `${baseApiUrl}/ciclopessoas/resumo/${this.$store.getters.getIdenPessoa}`
                  )
                  .then((res3) => {
                    this.$store.commit(
                      "setCicloPessoa",
                      JSON.stringify(res3.data)
                    );
                    if (
                      this.$store.getters.getCicloPessoa.length > 0 &&
                      this.$store.getters.getCicloPessoa[0].vinculosAtivos
                        .length > 0 &&
                      this.$store.getters.getCicloPessoa[0].vinculosAtivos[0]
                        .numrProtocolo
                    ) {
                      this.$router.push({ name: "recadastramento" });
                    } else {
                      this.$router.push({
                        name: "RECAD_EXPERIENCIA_PROFISSIONAL_VIEW",
                      });
                    }
                  });
              });
          });
      } else {
        this.$router.push({ name: "recadastramento" });
      }
    },
    fecharNovaCapacitacao() {
      this.novaCapacitacao();
      this.exibirNovaCapacitacao = false;
    },
    verificaAlteracaoDeCampo() {
      if (this.dadosCapacitacao.descCurso) {
        this.camposPreenchidos = true;
      } else if (this.dadosCapacitacao.areaFormacao) {
        this.camposPreenchidos = true;
      } else if (this.dadosCapacitacao.areaConhecimento) {
        this.camposPreenchidos = true;
      } else if (this.dadosCapacitacao.formacaoContinuada) {
        this.camposPreenchidos = true;
      } else if (this.dadosCapacitacao.qtdeCargaHoraria) {
        this.camposPreenchidos = true;
      } else if (this.dadosCapacitacao.descInstituicao) {
        this.camposPreenchidos = true;
      } else if (this.dadosCapacitacao.dataAnoConclusao) {
        this.camposPreenchidos = true;
      }
    },
    nextPage() {
      this.$router.push({ name: "RECAD_EXPERIENCIA_PROFISSIONAL_VIEW" });
    },
    prevPage() {
      this.$router.push({ name: "RECAD_FORMACAO_ACADEMICA_VIEW" });
    },

    verifcarModalidade(codigoModalidade) {
      let codigoModalidadeAux = this.modalidades.find(
        (item) => item.code == codigoModalidade
      );
      return codigoModalidadeAux.name;
    }, //codigoModalidade.find()

    especialCharMask(str) {
      str = str.replace(/[àáâãäå]/g, "a");
      str = str.replace(/[ÀÁÂÃÄÅ]/g, "A");

      str = str.replace(/[éèêë]/g, "e");
      str = str.replace(/[ÉÈÊË]/g, "E");

      str = str.replace(/[íìîï]/g, "i");
      str = str.replace(/[ÍÌÎÏ]/g, "I");

      str = str.replace(/[óòõôö]/g, "o");
      str = str.replace(/[ÓÒÕÔÖ]/g, "O");

      str = str.replace(/[úùûü]/g, "u");
      str = str.replace(/[ÚÙÛÜ]/g, "U");

      str = str.replace(/[ç]/g, "c");
      str = str.replace(/[Ç]/g, "C");

      str = str.replace(/[!@#$%¬&*=+/?|°ºª§´^~¨()_"]/g, "");

      return str;
    },

    converteMaiuscula(atributo) {
      if (atributo == "dadosCapacitacao.descCurso") {
        this.dadosCapacitacao.descCurso = this.especialCharMask(
          this.dadosCapacitacao.descCurso.toUpperCase()
        );
      } else if (atributo == "dadosCapacitacao.descInstituicao") {
        this.dadosCapacitacao.descInstituicao = this.especialCharMask(
          this.dadosCapacitacao.descInstituicao.toUpperCase()
        );
      }
    },

    searchDescCurso() {
      let qtdCaracteres = 2;
      if (this.dadosCapacitacao.descCurso.length >= qtdCaracteres) {
        this.$http
          .post(
            `${baseApiUrl}/capacitacoes/buscarDescricaoCurso/`,
            this.dadosCapacitacao.descCurso
          )
          .then((res) => {
            this.resultadoBusca = res.data;
          });
      }
    },

    searchDescInstituicao() {
      let qtdCaracteres = 2;
      if (this.dadosCapacitacao.descInstituicao.length >= qtdCaracteres) {
        this.$http
          .post(
            `${baseApiUrl}/capacitacoes/buscarDescricaoInstituicao/`,
            this.dadosCapacitacao.descInstituicao
          )
          .then((res) => {
            this.resultadoBusca = res.data;
          });
      }
    },
    searchFormacao(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.teste = [...this.listaCursos];
        } else {
          this.teste = this.listaCursos.filter((item) => {
            return item.match(new RegExp(event.query, "i"));
          });
        }
      }, 250);
    },
    funcaoAccord(index) {
      this.controlePanel[index] = this.isCollapsed;
      this.isCollapsed = !this.isCollapsed;
      this.controlePanel[index] = this.colapseTeste[index];
      this.colapseTeste[index] = !this.colapseTeste[index];
    },

    exibeNovaCapacitacaoEScroolaParaOInicio(){  
    this.exibirNovaCapacitacao = true;
    window.scrollTo(0, 0);
  }
  },
  mounted() {
    this.carregarDados();
  },

};


</script>
<style>
.docConcluido {
  color: #43a047;
  margin-top: 2px;
  margin-left: 15px;
}

.docPendente {
  color: #f2bf27;
  margin-top: 2px;
  margin-left: 15px;
}

.statusVinculoPendente {
  color: #f2bf27;
  margin-right: 3px;
}

.statusVinculoIrregular {
  color: #f27777;
  margin-right: 3px;
}

.statusVinculoConcluido {
  color: #43a047;
  margin-right: 3px;
}

.divcontainerButton {
  margin-top: 1rem;
  width: 100%;
}

.divButton {
  width: 10% !important;
}

.pendenteEdicao {
  color: orange;
}

.ajusteSecao {
  margin-top: 20px;
}

.ajustaBotao {
  /* justify-items: ; */
  justify-content: space-between;
  margin-top: 20px;
}

.ajustePanel {
  margin-top: -15px;
}

.ajusteContent {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start !important;
  justify-items: flex-start;
  margin-right: 1500px;
}

.acordion {
  display: none;
}
</style>
